<!--
/**
 * Modal component for text content
 *
 * Usage:
 *
 * ```
 * import TextModal from '?/Component/ModalContent/Text';
 *
 * // @event activate-modal
 * emitter.emit('activate-modal', {
 *     component: TextModal,
 *     title: 'Test Title',
 *     defaultCloseButton: true,
 *     data: {
 *         text: 'Lorem Ipsum'
 *     }
 * });
 * ```
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */
 -->

<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        data: {
            type: Object,
            required: true
          }
    });
</script>

<template>
    {{ props.data.text }}
</template>
